import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { DirectionalHint, mergeStyleSets, Text } from '@fluentui/react';
import { NeutralColors } from '@fluentui/theme';
import Tooltip from '@shared/components/tooltip';
import { getPriceWithCurrencySymbol } from '@shared/utils/pricing';
const classes = mergeStyleSets({
    subtotalText: {
        fontWeight: 600,
        color: NeutralColors.gray160
    }
});
export const SaasSubtotalCell = ({ sku, price, billingCountry, locale }, context)=>{
    const { countryCode } = billingCountry;
    const subtotalPriceText = getPriceWithCurrencySymbol(price.value, countryCode, sku.currencyCode, 2, locale);
    const subtotalText = sku.isQuantifiable ? context.locParams('Pricing_Multiyear_Subtotal_Per_User', [
        subtotalPriceText
    ], `${subtotalPriceText}/user`) : subtotalPriceText;
    return /*#__PURE__*/ _jsx(Tooltip, {
        tooltipHostProps: {
            content: subtotalText,
            directionalHint: DirectionalHint.bottomLeftEdge
        },
        children: /*#__PURE__*/ _jsx(Text, {
            className: classes.subtotalText,
            children: subtotalText
        })
    });
};
SaasSubtotalCell.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
